<script lang="ts">
	import { fade } from 'svelte/transition';
	import { twMerge } from 'tailwind-merge';
	import Spinner from '$lib/components/Spinner.svelte';

	let className = '';
	export let type: 'button' | 'submit' | 'reset' | undefined = 'button';
	export { className as class };
	export let ariaLabel = '';
	export let size = 'md';
	export let outline = false;
	export let color = 'primary';
	export let ghost = false;
	export let form = false;
	export let formaction: string | undefined = undefined;
	export let waiting = false;
	export let disabled = false;
	export let id: string | undefined = undefined;

	const BASE_BUTTON_STYLES =
		'flex items-center justify-center whitespace-nowrap rounded-full bg-primary-400 px-10 py-2.5 font-mundial text-sm font-semibold uppercase tracking-wider text-black transition-all hover:bg-primary-500';
	const BUTTON_SIZES = {
		sm: 'px-6 py-1.5 text-xs',
		lg: 'md:text-md px-12 py-2.5 text-sm md:px-16 md:py-4'
	};

	// Function to handle the color variations for the button when outline is true
	function getOutlineButtonVariations(color: string) {
		let colorClasses = `border-${color}-500 bg-transparent text-${color}-500 hover:${color === 'red' ? 'bg' : 'text'}-${color}-500`;
		if (color === 'black') colorClasses += ' hover:text-primary-700';
		return colorClasses;
	}

	function getClassNames() {
		return twMerge(
			BASE_BUTTON_STYLES,
			BUTTON_SIZES[size] || '',
			outline && getOutlineButtonVariations(color),
			!outline && color === 'secondary' && 'bg-secondary-500 text-white hover:bg-secondary-600',
			!outline && color === 'black' && 'bg-black text-white hover:bg-black hover:text-primary-500',
			color === 'red' && 'bg-red-500 text-white hover:bg-red-600',
			color === 'gray' && 'bg-gray-200 text-black hover:bg-gray-300',
			color === 'black' && ghost && 'text-black hover:text-white',
			form && 'flex h-[37px] items-center justify-center rounded-lg px-4',
			form && outline && 'bg-transparent',
			ghost && 'bg-transparent',
			disabled && 'cursor-not-allowed opacity-30',
			waiting && 'opacity-30',
			color === 'blue' && 'bg-secondary-300 text-secondary-950 hover:bg-secondary-500',
			className
		);
	}
</script>

<button
	{type}
	aria-label={ariaLabel}
	{formaction}
	disabled={waiting || disabled}
	{id}
	on:click
	class={getClassNames()}
>
	<span class="relative flex gap-4 pt-[2px]">
		<span class="transition-all {waiting ? ' opacity-0' : 'opacity-100'}">
			<slot />
		</span>
		{#if waiting}
			<span
				in:fade
				class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-all {waiting
					? ' opacity-100'
					: 'opacity-0'}"
			>
				<Spinner
					class="h-5 w-5 border-4 {color === 'primary' || color === 'grey'
						? 'border-black'
						: 'border-white'}"
				/>
			</span>
		{/if}
	</span>
</button>
